/**
 * The generation lock's window, in one dependency-free module so the backend
 * lock, the readers that interpret its marker, and the web panels all share it.
 * (Imported by web/, so keep it free of firebase and node imports.)
 */

/** Longest `timeoutSeconds` any function that takes the lock declares. */
export const LONGEST_GENERATION_TIMEOUT_SECONDS = 1800;

/** Margin beyond the longest run before a marker may be taken over. */
export const GENERATION_LOCK_MARGIN_SECONDS = 5 * 60;

/** A marker older than this is a crashed run, not a live one. */
export const GENERATION_LOCK_STALE_MINUTES =
  (LONGEST_GENERATION_TIMEOUT_SECONDS + GENERATION_LOCK_MARGIN_SECONDS) / 60;

export const GENERATION_LOCK_STALE_MS = GENERATION_LOCK_STALE_MINUTES * 60 * 1000;
